// This file is automatically generated from Rails routes.
// DO NOT modify it manually.
// To regenerate, run: bin/rake gitlab:js:routes

import { __jsr } from '~/lib/utils/path_helpers/core';
import { hasOrganizationScopedPaths } from '~/lib/utils/path_helpers/utils';


/**
 * Generates the Rails route:
 *
 * - href: `/-/profile/audit_log(.:format)`
 * - Path helper: `audit_log_profile_path`
 * - URL helper: `audit_log_profile_url`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auditLogProfilePath = /*#__PURE__*/ (...args) => {
  const _auditLogOrganizationProfilePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"audit_log"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _auditLogProfilePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"audit_log"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _auditLogOrganizationProfilePath(gon.current_organization.path, ...args);
  }

  return _auditLogProfilePath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/profile/applications(.:format)`
 * - Path helper: `applications_profile_path`
 * - URL helper: `applications_profile_url`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const applicationsProfilePath = /*#__PURE__*/ (...args) => {
  const _applicationsOrganizationProfilePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"applications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _applicationsProfilePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"applications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _applicationsOrganizationProfilePath(gon.current_organization.path, ...args);
  }

  return _applicationsProfilePath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/profile/reset_incoming_email_token(.:format)`
 * - Path helper: `reset_incoming_email_token_profile_path`
 * - URL helper: `reset_incoming_email_token_profile_url`
 * - controller#action: `profiles#reset_incoming_email_token`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resetIncomingEmailTokenProfilePath = /*#__PURE__*/ (...args) => {
  const _resetIncomingEmailTokenOrganizationProfilePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"reset_incoming_email_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _resetIncomingEmailTokenProfilePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"reset_incoming_email_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _resetIncomingEmailTokenOrganizationProfilePath(gon.current_organization.path, ...args);
  }

  return _resetIncomingEmailTokenProfilePath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/profile/reset_feed_token(.:format)`
 * - Path helper: `reset_feed_token_profile_path`
 * - URL helper: `reset_feed_token_profile_url`
 * - controller#action: `profiles#reset_feed_token`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resetFeedTokenProfilePath = /*#__PURE__*/ (...args) => {
  const _resetFeedTokenOrganizationProfilePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"reset_feed_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _resetFeedTokenProfilePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"reset_feed_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _resetFeedTokenOrganizationProfilePath(gon.current_organization.path, ...args);
  }

  return _resetFeedTokenProfilePath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/profile/reset_static_object_token(.:format)`
 * - Path helper: `reset_static_object_token_profile_path`
 * - URL helper: `reset_static_object_token_profile_url`
 * - controller#action: `profiles#reset_static_object_token`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resetStaticObjectTokenProfilePath = /*#__PURE__*/ (...args) => {
  const _resetStaticObjectTokenOrganizationProfilePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"reset_static_object_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _resetStaticObjectTokenProfilePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"reset_static_object_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _resetStaticObjectTokenOrganizationProfilePath(gon.current_organization.path, ...args);
  }

  return _resetStaticObjectTokenProfilePath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/profile/update_username(.:format)`
 * - Path helper: `update_username_profile_path`
 * - URL helper: `update_username_profile_url`
 * - controller#action: `profiles#update_username`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateUsernameProfilePath = /*#__PURE__*/ (...args) => {
  const _updateUsernameOrganizationProfilePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"update_username"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _updateUsernameProfilePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"update_username"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _updateUsernameOrganizationProfilePath(gon.current_organization.path, ...args);
  }

  return _updateUsernameProfilePath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/profile/account/unlink(.:format)`
 * - Path helper: `unlink_profile_account_path`
 * - URL helper: `unlink_profile_account_url`
 * - controller#action: `profiles/accounts#unlink`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unlinkProfileAccountPath = /*#__PURE__*/ (...args) => {
  const _unlinkOrganizationProfileAccountPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"unlink"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _unlinkProfileAccountPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"unlink"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _unlinkOrganizationProfileAccountPath(gon.current_organization.path, ...args);
  }

  return _unlinkProfileAccountPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/profile/account/generate_support_pin(.:format)`
 * - Path helper: `generate_support_pin_profile_account_path`
 * - URL helper: `generate_support_pin_profile_account_url`
 * - controller#action: `profiles/accounts#generate_support_pin`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generateSupportPinProfileAccountPath = /*#__PURE__*/ (...args) => {
  const _generateSupportPinOrganizationProfileAccountPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"generate_support_pin"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _generateSupportPinProfileAccountPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"generate_support_pin"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _generateSupportPinOrganizationProfileAccountPath(gon.current_organization.path, ...args);
  }

  return _generateSupportPinProfileAccountPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/profile/account(.:format)`
 * - Path helper: `profile_account_path`
 * - URL helper: `profile_account_url`
 * - controller#action: `profiles/accounts#show`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const profileAccountPath = /*#__PURE__*/ (...args) => {
  const _organizationProfileAccountPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"account"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _profileAccountPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"account"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationProfileAccountPath(gon.current_organization.path, ...args);
  }

  return _profileAccountPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/profile/groups/*id/notifications(.:format)`
 * - Path helper: `profile_group_notifications_path`
 * - URL helper: `profile_group_notifications_url`
 * - controller#action: `profiles/groups#update`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const profileGroupNotificationsPath = /*#__PURE__*/ (...args) => {
  const _organizationProfileGroupNotificationsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"id"]],[2,[7,"/"],[2,[6,"notifications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _profileGroupNotificationsPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"id"]],[2,[7,"/"],[2,[6,"notifications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationProfileGroupNotificationsPath(gon.current_organization.path, ...args);
  }

  return _profileGroupNotificationsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/profile/notifications(.:format)`
 * - Path helper: `profile_notifications_path`
 * - URL helper: `profile_notifications_url`
 * - controller#action: `profiles/notifications#show`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const profileNotificationsPath = /*#__PURE__*/ (...args) => {
  const _organizationProfileNotificationsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"notifications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _profileNotificationsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"notifications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationProfileNotificationsPath(gon.current_organization.path, ...args);
  }

  return _profileNotificationsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/profile/slack/slack_link(.:format)`
 * - Path helper: `slack_link_profile_slack_path`
 * - URL helper: `slack_link_profile_slack_url`
 * - controller#action: `profiles/slacks#slack_link`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const slackLinkProfileSlackPath = /*#__PURE__*/ (...args) => {
  const _slackLinkOrganizationProfileSlackPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"slack"],[2,[7,"/"],[2,[6,"slack_link"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _slackLinkProfileSlackPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"slack"],[2,[7,"/"],[2,[6,"slack_link"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _slackLinkOrganizationProfileSlackPath(gon.current_organization.path, ...args);
  }

  return _slackLinkProfileSlackPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/profile/slack/edit(.:format)`
 * - Path helper: `edit_profile_slack_path`
 * - URL helper: `edit_profile_slack_url`
 * - controller#action: `profiles/slacks#edit`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editProfileSlackPath = /*#__PURE__*/ (...args) => {
  const _editOrganizationProfileSlackPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"slack"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _editProfileSlackPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"slack"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _editOrganizationProfileSlackPath(gon.current_organization.path, ...args);
  }

  return _editProfileSlackPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/profile/preferences(.:format)`
 * - Path helper: `profile_preferences_path`
 * - URL helper: `profile_preferences_url`
 * - controller#action: `profiles/preferences#show`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const profilePreferencesPath = /*#__PURE__*/ (...args) => {
  const _organizationProfilePreferencesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"preferences"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _profilePreferencesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"preferences"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationProfilePreferencesPath(gon.current_organization.path, ...args);
  }

  return _profilePreferencesPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/profile/comment_templates(.:format)`
 * - Path helper: `profile_comment_templates_path`
 * - URL helper: `profile_comment_templates_url`
 * - controller#action: `profiles/comment_templates#index`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const profileCommentTemplatesPath = /*#__PURE__*/ (...args) => {
  const _organizationProfileCommentTemplatesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"comment_templates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _profileCommentTemplatesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"comment_templates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationProfileCommentTemplatesPath(gon.current_organization.path, ...args);
  }

  return _profileCommentTemplatesPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/profile/comment_templates/:id(.:format)`
 * - Path helper: `profile_comment_template_path`
 * - URL helper: `profile_comment_template_url`
 * - controller#action: `profiles/comment_templates#index`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const profileCommentTemplatePath = /*#__PURE__*/ (...args) => {
  const _organizationProfileCommentTemplatePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"comment_templates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _profileCommentTemplatePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"comment_templates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationProfileCommentTemplatePath(gon.current_organization.path, ...args);
  }

  return _profileCommentTemplatePath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/profile/emails/:id/resend_confirmation_instructions(.:format)`
 * - Path helper: `resend_confirmation_instructions_profile_email_path`
 * - URL helper: `resend_confirmation_instructions_profile_email_url`
 * - controller#action: `profiles/emails#resend_confirmation_instructions`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resendConfirmationInstructionsProfileEmailPath = /*#__PURE__*/ (...args) => {
  const _resendConfirmationInstructionsOrganizationProfileEmailPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resend_confirmation_instructions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _resendConfirmationInstructionsProfileEmailPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resend_confirmation_instructions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _resendConfirmationInstructionsOrganizationProfileEmailPath(gon.current_organization.path, ...args);
  }

  return _resendConfirmationInstructionsProfileEmailPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/profile/emails(.:format)`
 * - Path helper: `profile_emails_path`
 * - URL helper: `profile_emails_url`
 * - controller#action: `profiles/emails#index`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const profileEmailsPath = /*#__PURE__*/ (...args) => {
  const _organizationProfileEmailsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _profileEmailsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationProfileEmailsPath(gon.current_organization.path, ...args);
  }

  return _profileEmailsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/profile/emails/:id(.:format)`
 * - Path helper: `profile_email_path`
 * - URL helper: `profile_email_url`
 * - controller#action: `profiles/emails#destroy`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const profileEmailPath = /*#__PURE__*/ (...args) => {
  const _organizationProfileEmailPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _profileEmailPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationProfileEmailPath(gon.current_organization.path, ...args);
  }

  return _profileEmailPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/profile/avatar(.:format)`
 * - Path helper: `profile_avatar_path`
 * - URL helper: `profile_avatar_url`
 * - controller#action: `profiles/avatars#destroy`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const profileAvatarPath = /*#__PURE__*/ (...args) => {
  const _organizationProfileAvatarPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"avatar"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _profileAvatarPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"avatar"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationProfileAvatarPath(gon.current_organization.path, ...args);
  }

  return _profileAvatarPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/profile/chat_names(.:format)`
 * - Path helper: `chat_names_profile_path`
 * - URL helper: `chat_names_profile_url`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const chatNamesProfilePath = /*#__PURE__*/ (...args) => {
  const _chatNamesOrganizationProfilePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"chat_names"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _chatNamesProfilePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"chat_names"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _chatNamesOrganizationProfilePath(gon.current_organization.path, ...args);
  }

  return _chatNamesProfilePath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/profile/chat_names/new(.:format)`
 * - Path helper: `chat_names_new_profile_path`
 * - URL helper: `chat_names_new_profile_url`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const chatNamesNewProfilePath = /*#__PURE__*/ (...args) => {
  const _chatNamesNewOrganizationProfilePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"chat_names"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _chatNamesNewProfilePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"chat_names"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _chatNamesNewOrganizationProfilePath(gon.current_organization.path, ...args);
  }

  return _chatNamesNewProfilePath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/profile/two_factor_auth/codes(.:format)`
 * - Path helper: `codes_profile_two_factor_auth_path`
 * - URL helper: `codes_profile_two_factor_auth_url`
 * - controller#action: `profiles/two_factor_auths#codes`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const codesProfileTwoFactorAuthPath = /*#__PURE__*/ (...args) => {
  const _codesOrganizationProfileTwoFactorAuthPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"two_factor_auth"],[2,[7,"/"],[2,[6,"codes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _codesProfileTwoFactorAuthPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"two_factor_auth"],[2,[7,"/"],[2,[6,"codes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _codesOrganizationProfileTwoFactorAuthPath(gon.current_organization.path, ...args);
  }

  return _codesProfileTwoFactorAuthPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/profile/two_factor_auth/skip(.:format)`
 * - Path helper: `skip_profile_two_factor_auth_path`
 * - URL helper: `skip_profile_two_factor_auth_url`
 * - controller#action: `profiles/two_factor_auths#skip`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const skipProfileTwoFactorAuthPath = /*#__PURE__*/ (...args) => {
  const _skipOrganizationProfileTwoFactorAuthPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"two_factor_auth"],[2,[7,"/"],[2,[6,"skip"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _skipProfileTwoFactorAuthPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"two_factor_auth"],[2,[7,"/"],[2,[6,"skip"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _skipOrganizationProfileTwoFactorAuthPath(gon.current_organization.path, ...args);
  }

  return _skipProfileTwoFactorAuthPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/profile/two_factor_auth/create_webauthn(.:format)`
 * - Path helper: `create_webauthn_profile_two_factor_auth_path`
 * - URL helper: `create_webauthn_profile_two_factor_auth_url`
 * - controller#action: `profiles/two_factor_auths#create_webauthn`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createWebauthnProfileTwoFactorAuthPath = /*#__PURE__*/ (...args) => {
  const _createWebauthnOrganizationProfileTwoFactorAuthPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"two_factor_auth"],[2,[7,"/"],[2,[6,"create_webauthn"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _createWebauthnProfileTwoFactorAuthPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"two_factor_auth"],[2,[7,"/"],[2,[6,"create_webauthn"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _createWebauthnOrganizationProfileTwoFactorAuthPath(gon.current_organization.path, ...args);
  }

  return _createWebauthnProfileTwoFactorAuthPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/profile/two_factor_auth/destroy_otp(.:format)`
 * - Path helper: `destroy_otp_profile_two_factor_auth_path`
 * - URL helper: `destroy_otp_profile_two_factor_auth_url`
 * - controller#action: `profiles/two_factor_auths#destroy_otp`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroyOtpProfileTwoFactorAuthPath = /*#__PURE__*/ (...args) => {
  const _destroyOtpOrganizationProfileTwoFactorAuthPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"two_factor_auth"],[2,[7,"/"],[2,[6,"destroy_otp"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _destroyOtpProfileTwoFactorAuthPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"two_factor_auth"],[2,[7,"/"],[2,[6,"destroy_otp"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _destroyOtpOrganizationProfileTwoFactorAuthPath(gon.current_organization.path, ...args);
  }

  return _destroyOtpProfileTwoFactorAuthPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/profile/two_factor_auth/destroy_webauthn/:id(.:format)`
 * - Path helper: `destroy_webauthn_profile_two_factor_auth_path`
 * - URL helper: `destroy_webauthn_profile_two_factor_auth_url`
 * - controller#action: `profiles/two_factor_auths#destroy_webauthn`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroyWebauthnProfileTwoFactorAuthPath = /*#__PURE__*/ (...args) => {
  const _destroyWebauthnOrganizationProfileTwoFactorAuthPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"two_factor_auth"],[2,[7,"/"],[2,[6,"destroy_webauthn"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _destroyWebauthnProfileTwoFactorAuthPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"two_factor_auth"],[2,[7,"/"],[2,[6,"destroy_webauthn"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _destroyWebauthnOrganizationProfileTwoFactorAuthPath(gon.current_organization.path, ...args);
  }

  return _destroyWebauthnProfileTwoFactorAuthPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/profile/two_factor_auth(.:format)`
 * - Path helper: `profile_two_factor_auth_path`
 * - URL helper: `profile_two_factor_auth_url`
 * - controller#action: `profiles/two_factor_auths#show`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const profileTwoFactorAuthPath = /*#__PURE__*/ (...args) => {
  const _organizationProfileTwoFactorAuthPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"two_factor_auth"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _profileTwoFactorAuthPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"two_factor_auth"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationProfileTwoFactorAuthPath(gon.current_organization.path, ...args);
  }

  return _profileTwoFactorAuthPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/profile/passkeys(.:format)`
 * - Path helper: `profile_passkeys_path`
 * - URL helper: `profile_passkeys_url`
 * - controller#action: `profiles/passkeys#create`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const profilePasskeysPath = /*#__PURE__*/ (...args) => {
  const _organizationProfilePasskeysPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"passkeys"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _profilePasskeysPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"passkeys"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationProfilePasskeysPath(gon.current_organization.path, ...args);
  }

  return _profilePasskeysPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/profile/passkeys/new(.:format)`
 * - Path helper: `new_profile_passkey_path`
 * - URL helper: `new_profile_passkey_url`
 * - controller#action: `profiles/passkeys#new`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newProfilePasskeyPath = /*#__PURE__*/ (...args) => {
  const _newOrganizationProfilePasskeyPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"passkeys"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _newProfilePasskeyPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"passkeys"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _newOrganizationProfilePasskeyPath(gon.current_organization.path, ...args);
  }

  return _newProfilePasskeyPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/profile/passkeys/:id(.:format)`
 * - Path helper: `profile_passkey_path`
 * - URL helper: `profile_passkey_url`
 * - controller#action: `profiles/passkeys#destroy`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const profilePasskeyPath = /*#__PURE__*/ (...args) => {
  const _organizationProfilePasskeyPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"passkeys"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _profilePasskeyPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"passkeys"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationProfilePasskeyPath(gon.current_organization.path, ...args);
  }

  return _profilePasskeyPath(...args);
};

